// ABOUTME: One-line text of a job's resources ("requests cpu 500m, memory 1Gi · limits memory 2Gi").
// ABOUTME: Empty when the run used no explicit resources.

import { JobResources } from '../../../types';

const formatSection = (section: Record<string, string> | undefined) =>
    Object.entries(section ?? {})
        .map(([resource, quantity]) => `${resource} ${quantity}`)
        .join(', ');

export const formatResources = (
    resources: JobResources | null | undefined,
    labels: { requests: string; limits: string },
): string => {
    const requests = formatSection(resources?.requests);
    const limits = formatSection(resources?.limits);
    return [requests && `${labels.requests} ${requests}`, limits && `${labels.limits} ${limits}`]
        .filter(Boolean)
        .join(' · ');
};
